import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';

const LayoutPage = ({ listStages, listStagesAudit, listStagesAuditFooter }) => {
    return (
        <div className="pochtabank-layout-page">
            <FullWrapper caseName="pochtabank-layout-pageCase">
                <div className="pochtabank-layout-pageWrapper">
                    <div className="pochtabank-layout-pageTitle">Описание проекта</div>

                    <div className="pochtabank-layout-pageMiddle">
                        Разработка сайта крупного банка&nbsp;&mdash; это вызов и&nbsp;для заказчика,
                        и&nbsp;для разработчиков. Нужно учесть много нюансов: тяжелый функционал,
                        максимальная безопасность, высокая скорость работы. Расскажем, как создавали
                        уникальное техническое решение на&nbsp;базе 1С-Битрикс, с&nbsp;чем пришлось
                        столкнуться, чтобы в&nbsp;сверхсжатые сроки запустить совершенную новую
                        версию сайта одного из&nbsp;крупнейших российских банков.
                    </div>

                    <div className="pochtabank-layout-pageBottom">Задачи</div>

                    {listStages.map((item, index) => (
                        <div className="pochtabank-layout-pageList" key={index}>
                            <div className="pochtabank-layout-pageListNumber">{item.number}</div>
                            <div
                                className="pochtabank-layout-pageListText"
                                dangerouslySetInnerHTML={{ __html: item.text }}
                            />
                        </div>
                    ))}
                </div>
            </FullWrapper>

            <div className="pochtabank-layout-pageContainer">
                <img
                    src="/images/pic/new-pochtabank/layoutBanner.jpg"
                    alt="banner"
                    className="otpBank-layout-pageBanner"
                />
            </div>

            <FullWrapper caseName="pochtabank-layout-pageCenter">
                <div className="pochtabank-layout-pageInner">
                    <div className="pochtabank-layout-pageLeft">
                        <div>
                            В&nbsp;больших корпорациях не&nbsp;всегда получается быстро принимать
                            инновационные решения. Идея создания новой версии сайта созревала
                            несколько лет. В&nbsp;это время у&nbsp;старой версии было несколько
                            системных проблем, которые нужно было решить:
                        </div>
                        {listStagesAudit.map((item, index) => (
                            <div className="pochtabank-layout-pageSubList" key={index}>
                                <div className="pochtabank-layout-pageSubListCircle" />
                                <div
                                    className="pochtabank-layout-pageSubListText"
                                    dangerouslySetInnerHTML={{ __html: item.text }}
                                />
                            </div>
                        ))}
                    </div>
                    <div className="pochtabank-layout-pageRight">
                        <div className="pochtabank-layout-pageRightText">
                            Старый движок делал поддержку проекта дорогой и&nbsp;не&nbsp;оперативной
                        </div>
                        <div className="pochtabank-layout-pageRightItem">
                            <img
                                src="/images/pic/new-pochtabank/pngegg 1.jpg"
                                className="pochtabank-layout-pageRightIcon"
                            />
                            <div className="pochtabank-layout-pageRightName">С#</div>
                        </div>
                    </div>
                </div>
            </FullWrapper>

            <FullWrapper caseName="pochtabank-layout-pageFooter">
                <div className="pochtabank-layout-pageInner">
                    <div className="pochtabank-layout-pageLeft">
                        <div>
                            Отказоустойчивость, масштабируемость
                            и&nbsp;распределенность&nbsp;&mdash; одни из&nbsp;основных требований
                            к&nbsp;созданию нового сайта. Проект сразу закладывал большое количество
                            ежемесячных задач по&nbsp;развитию и&nbsp;нужно было сразу использовать
                            &laquo;взрослые&raquo; решения, которые позволили&nbsp;бы проекту
                            не&nbsp;обрастать техническим долгом. Также стояла задача увеличить
                            скорость работы сайта и&nbsp;создать конструктор для быстрого
                            и&nbsp;удобного редактирования контента.
                        </div>
                        <div className="pochtabank-layout-pageRightDescription">
                            Заказчик уже на уровне выбора подрядчика понимал, что разработка
                            будущего проекта будет вестись на базе 1С-Битрикс, опираясь на
                            преимущества этого решения:
                        </div>
                        {listStagesAuditFooter.map((item, index) => (
                            <div className="pochtabank-layout-pageSubList" key={index}>
                                <div className="pochtabank-layout-pageSubListCircle" />
                                <div
                                    className="pochtabank-layout-pageSubListText"
                                    dangerouslySetInnerHTML={{ __html: item.text }}
                                />
                            </div>
                        ))}
                    </div>
                    <div className="pochtabank-layout-pageRight">
                        <div className="pochtabank-layout-pageRightText">
                            Стояла задача увеличить скорость работы сайта и&nbsp;создать конструктор
                            для быстрого и&nbsp;удобного редактирования контента.
                        </div>
                    </div>
                </div>
            </FullWrapper>
        </div>
    );
};

export default LayoutPage;
